import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface ArcadeLink {
  id: number;
  name: string;
  title: string;
  link: string;
  description?: string;
  category?: string;
  visibleto: number;
  thumbnail:string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class ArcadeLinkService {
  private http = inject(HttpClient);

  private base = environment.nodeApiUrl.replace(/\/$/, '');

  getAllArcadeLinks(): Observable<ArcadeLink[]> {
    const url = `${this.base}/arcade-link`;
    console.log('[ArcadeLinkService] GET', url);
    return this.http
      .get<ApiResponse<ArcadeLink[]>>(url)
      .pipe(
        map((res) => res?.data ?? []),
        catchError((err: HttpErrorResponse) => {
          console.error('[ArcadeLinkService] getAllArcadeLinks failed', err.status, err.message, err);
          return throwError(() => err);
        })
      );
  }

  getArcadeLinkById(id: number): Observable<ArcadeLink> {
    return this.http
      .get<ApiResponse<ArcadeLink>>(`${this.base}/arcade-link/${id}`)
      .pipe(map((res) => res.data));
  }
}
